import { FaultData } from "@fairfleet/geotab";
import { useState, useEffect } from "react";
import { faultComparator } from "./faultComparator";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";

export const useSortedFaultData = (
  faultData: FaultData[],
  descriptions: DiagnosticAddinData[],
  deviceGroupIds: string[] = [],
) => {
  const [sortedFaults, setSortedFaults] = useState<FaultData[]>([]);

  useEffect(() => {
    if (faultData.length > 0) {
      const sorted = [...faultData].sort(faultComparator(descriptions, deviceGroupIds));
      setSortedFaults(sorted);
    }
  }, [faultData, descriptions, deviceGroupIds]);

  return sortedFaults;
};
